<template>
    <a :href="`/products/${slug}`" v-on:click="window.analytics.track('Clicked Preview Button', {slug: slug})">
      <i class="ti-eye"></i>
    </a>
</template>

<script>
export default {
  props: ['slug']
}
</script>



// WEBPACK FOOTER //
// src/components/PreviewButton.vue